<template>
  <div class="ready">
    <img src="../assets/thumb_up.png" srcset="../assets/thumb_up.png 1x, ../assets/thumb_up@2x.png 2x, ../assets/thumb_up@3x.png" alt="Ready">
    <p>That’s it! Let’s play Spot the Not</p>
    <Button text="Start" @click.native="goToSpotTheNot" />
    <RotateMessage :portrait="portrait" />
  </div>
</template>

<script>
import Button from '@/components/Button.vue'
import RotateMessage from '@/components/RotateMessage.vue'

export default {
  components: {
    Button,
    RotateMessage
  },
  data() {
    return {
      portrait: false
    }
  },
  methods: {
    goToSpotTheNot() {
      this.$router.push('/spot-the-not')
    },
    getOrientation() {
      if(screen.orientation.angle == 0) {
        this.portrait = true
      } else {
        this.portrait = false
      }
    }
  }
}
</script>

<style lang="scss">
.ready {
  height: 100%;
  padding-top: 40px;
  position: relative;
  width: 100%;

  p {
    font-size: 36px;
    font-weight: bold;
    margin-top: 25px;
  }
}
</style>